module.exports = __webpack_public_path__ + "img/ico-edit-user.d7bea81b.svg";